const properties = {
    backendServer: 'https://api.scriptvender.com',
    domain: 'https://www.scriptvender.com'
    // backendServer: 'http://localhost:8080',
    // domain: 'http://localhost:3000'

}
export default properties;